<template lang="pug">
.basketSpecialOffersItem
  template(v-if="item.special")
    .img.double
      img(:src="`/assets/images/basket-offers/${item.service}.png`")
      img(:src="`/assets/images/basket-offers/${item.special.item.service}.png`")
  template(v-else)
    .img
      img(:src="`/assets/images/basket-offers/${item.service}.png`")
  ui-price(:price="item.price" :old-price="item.oldPrice")
  .label {{ item.label }}
  ui-button.button(
    color="blue-lecta"
    @click="onButtonClick(item)"
  ) В корзину
</template>

<script>
import SpecialOffer from '../models/SpecialOffer'
import { inject } from 'vue'
export default {
  props: {
    item: {
      type: SpecialOffer,
      default: null
    }
  },
  setup () {
    const store = inject('store')
    const addToBasket = store.basket.addItem
    const onButtonClick = item => addToBasket(item)
    return { onButtonClick }
  }
}
</script>

<style lang="sass">
.basketSpecialOffersItem
  background-color: $cWhite
  border-radius: 10px
  padding: 15px
  // max-width: 235px
  // width: 100%
  width: 235px
  flex-shrink: 0
  display: flex
  flex-direction: column
  > .img
    display: flex
    height: 205px
    position: relative
    margin-bottom: 5*$u
    img
      width: 100%
      height: 100%
    &.double
      img
        position: absolute
        height: 125px
        width: 125px
        &:first-child
          top: 0
          left: 0
        &:last-child
          bottom: 0
          right: 0
  > .label
    @include font('t16-medium')
    margin: 15px 0
  > .button
    width: 100%
    margin-top: auto
</style>
